import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { EMPTY, from, throwError } from "rxjs";
import { catchError, finalize, switchMap } from "rxjs/operators";
import { LoaderService } from "../services/loader.service";
import { CalService } from "@app/auth/cal.service";

function addToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
  return request.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  });
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const calService = inject(CalService);

  if (req.url.includes('/assets/') || req.url.includes('config.json')) {
    return next(req);
  }

  const preventLoader =
    (req?.body as any)?.preventLoader ||
    req.params?.get('preventLoader') === 'true' ||
    (req.body instanceof FormData && req.body?.get('preventLoader') === 'true');

  if (!preventLoader) loaderService.loadSpinner(true);

  return from(calService.refreshToken()).pipe(
    switchMap(token => {
      const authReq = token ? addToken(req, token) : req;

      return next(authReq as any).pipe(
        catchError((error: HttpErrorResponse) => {
          let errorTitle: string = "", errorDetail = "";

          if (error.error instanceof ErrorEvent) {
              errorTitle = "Some Error Occurred";
            errorDetail = error.error.message;
          } 
          else {
            if (error?.error?.error !== undefined && error?.error?.error.metadata !== null) {
              return throwError(() => error?.error?.error);
            }

            if (error.status === 400) {
                errorTitle = "Bad Resource";
                errorDetail = error?.error?.error?.description;
              }
              else if (error.status === 404) {
                errorTitle = "Resource not found";
                errorDetail = error?.error?.error?.description;
            } 
            else if (error.status === 409) {
                errorTitle = "Duplicate resource found";
                errorDetail = error?.error?.error?.description;
              }
              else if (error.status === 401) {
                errorTitle = "User Unauthorized";
                errorDetail = error?.error?.detail;
                
              return from(calService.refreshToken()).pipe(
                switchMap(newToken => {
                  if (newToken) {
                    return next(addToken(req, newToken) as any);
                  }
                  return EMPTY;
                })
              );
            } else if (error.status === 403) {
              errorTitle = 'Insufficient Permission';
              errorDetail = error?.error?.detail;
            } else if (error.status === 500) {
              errorTitle = 'Internal Server Error';
              errorDetail = 'Some internal server error occurred, please try again in a few minutes.';
            } else {
              errorTitle = 'Service Unavailable';
              errorDetail = 'Currently service is not available, please try again after sometime.';
            }
          }

          return throwError(() => error);
        })
      );
    }),
    finalize(() => {
      if (!preventLoader) loaderService.loadSpinner(false);
    })
  );
};
